import { Component, OnInit, OnDestroy, Input, HostBinding } from '@angular/core';
import { SidePanelService } from '../../services/side-panel-service';

@Component({
    selector: 'sk-side-panel-tab',
    styles: [`

    `],
    template: `
        <div (click)="sidePanel.show()">Show</div>
    `,
})
export class SidePanelTabComponent implements OnInit, OnDestroy {

    constructor(
        public sidePanel: SidePanelService
    ) {
        
    }

    ngOnDestroy() {
       
    }

    demoSetNextStartDate() {
       
    }

    ngOnInit() {
    }

}
